import React from 'react';
import './ConfirmModal.css';

function ConfirmModal({ isOpen, onConfirm, onCancel, threshold }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">Confirm Classification Threshold</h3>
        <div className="modal-body">
          <p>You've selected a classification threshold of:</p>
          <div className="threshold-display">
            <span className="threshold-value">{threshold.toFixed(4)}</span>
          </div>
          <p className="threshold-explanation">
            Galaxies with <strong>p(Backsplash) ≥ {threshold.toFixed(4)}</strong> will be classified as <span className="backsplash-label">Backsplash</span>
          </p>
          <p className="threshold-explanation">
            Galaxies with <strong>p(Backsplash) &lt; {threshold.toFixed(4)}</strong> will be classified as <span className="infalling-label">Infalling</span>
          </p>
        </div>
        <div className="modal-actions">
          <button className="button button-secondary" onClick={onCancel}>
            ← Go Back
          </button>
          <button className="button" onClick={onConfirm}>
            Continue to Results →
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
